export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/industrial_product_design.4d96b78.svg";